<template lang="">
	<sf-modal-layout :title="getMessage_('MWCC000764')" :show="UploadFormModal" :closeModal="closeModal" size="L">
		<el-row :gutter="30">
			<el-col :span="8">
				<!-- 버전 -->
				<sf-input-group
					:label="getMessage_('MWCC000330')"
					labelPosition="left"
					:labelSpan="6"
					:inputValue="UploadFormModalValue.gqmsSeq"
					:onChange="value => setModalValue_({ key: 'gqmsSeq', value })"
					placeholder="일련번호"
				/>
			</el-col>
			<el-col :span="8">
				<!-- 싱세구분 -->
				<sf-input-group
					:label="getMessage_('MWCC000519')"
					labelPosition="left"
					:labelSpan="6"
					:inputValue="UploadFormModalValue.gqmsTitle"
					:onChange="value => setModalValue_({ key: 'gqmsTitle', value })"
					:elProps="{ maxlength: 10 }"
					placeholder="타이틀"
				/>
			</el-col>
			<el-col :span="8">
				<!-- 작성자 -->
				<sf-input-group
					:label="getMessage_('MWCC000848')"
					labelPosition="left"
					:labelSpan="6"
					:inputValue="UploadFormModalValue.regId"
					:onChange="value => setModalValue_({ key: 'regId', value })"
					placeholder="OOO"
				/>
			</el-col>
		</el-row>
		<el-row>
			<!-- 내용 -->
			<el-col :span="24">
				<sf-group-wrapper :label="getMessage_('MWCC000846')" :gutter="10" :labelSpan="5">
					<el-row :gutter="10">
						<el-col :span="24">
							<el-input
								id="lineHeight"
								type="textarea"
								v-model="UploadFormModalValue.gqmsConts"
								maxlength="4000"
								:rows="10"
								show-word-limit
								@change="value => setModalValue_({ key: 'gqmsConts', value })"
							/>
						</el-col>
					</el-row>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<el-row :gutter="30">
			<el-col :span="12">
				<sf-group-wrapper labelPosition="left" :label="getMessage_('MWCC000847')" :gutter="10" :labelSpan="5">
					<!-- <file-upload
						id="imgFile1"
						folder="TabSample"
						:v-model="UploadFormModalValue.imgFile1"
						@onChange="test()"
						@SingleFile="singleFile"
						style="height: 100px; border: solid"
					></file-upload> -->

					<el-upload
						action=""
						list-type="picture-card"
						:multiple="false"
						:limit="1"
						:auto-upload="false"
						:disabled="false"
						:file-list="UploadFormModalValue.imgFile1"
						:on-change="GeneralFileUploadChange1"
						:on-remove="handleUploadRemove1"
					>
						<i class="el-icon-plus"></i>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible1">
						<img width="100%" :src="dialogImageUrl1" alt="" />
					</el-dialog>
				</sf-group-wrapper>
			</el-col>

			<el-col :span="12">
				<sf-group-wrapper labelPosition="left" :label="getMessage_('MWCC000847')" :gutter="10" :labelSpan="5">
					<!-- <file-upload
						id="imgFile2"
						folder="TabSample"
						:v-model="UploadFormModalValue.imgfile2"
						@onChange="test()"
						@SingleFile="singleFile"
						style="height: 100px; border: solid"
					></file-upload> -->
					<el-upload
						action=""
						list-type="picture-card"
						:multiple="false"
						:limit="1"
						:auto-upload="false"
						:disabled="false"
						:file-list="UploadFormModalValue.imgFile2"
						:on-change="GeneralFileUploadChange2"
						:on-remove="handleUploadRemove2"
					>
						<i class="el-icon-plus"></i>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible2">
						<img width="100%" :src="dialogImageUrl2" alt="" />
					</el-dialog>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<!-- <el-row>
			<el-col :span="24">
				<el-upload
					class="upload-demo"
					action=""
					:auto-upload="false"
					:multiple="true"
					:limit="30"
					:on-change="GeneralFileUploadChange"
					:on-remove="handleUploadRemove"
					:file-list="UploadFormModalValue.fileList"
				>
					
					<sf-button slot="trigger" v-if="isButton_(scrId, 'AD')" icon="file">Select image</sf-button>
				</el-upload>
			</el-col>
		</el-row> -->
		<el-row>
			<el-col :span="24">
				<sf-group-wrapper labelPosition="left" :label="getMessage_('QWCC000925')" :gutter="10" :labelSpan="5">
					<file-upload-list
						id="fileList"
						:propFileList="rtnFile"
						@MultiFile="multiFile"
						style="height: 100px; border: solid"
						ref="fileArea"
					></file-upload-list>
				</sf-group-wrapper>
			</el-col>
		</el-row>
		<template v-slot:footer>
			<sf-button line :onClick="closeModal">{{ getMessage_('QWCC001971') }}</sf-button>
			<sf-button v-if="isButton_(scrId, 'AD') && UploadFormModalValue.flg == 'U'" :onClick="saveAction">{{
				getMessage_('MWCC000279')
			}}</sf-button>
			<sf-button v-if="isButton_(scrId, 'AD') && UploadFormModalValue.flg == 'I'" :onClick="addAction">{{
				getMessage_('QWCC001488')
			}}</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import FileUploadList from '@qms/Components/FileUploadList.vue';
// import FileUpload from '@qms/Components/FileUpload.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/UploadForm/store/helpers';
import * as yup from 'yup';

export default {
	components: { FileUploadList },
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			dialogImageUrl1: '',
			dialogImageUrl2: '',
			dialogVisible1: false,
			dialogVisible2: false
		};
	},
	created() {
		console.clear();
	},
	computed: {
		...rootComputed,
		...serviceComputed,

		schema() {
			return yup.object().shape({
				gqmsSeq: yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('MWCC000330')])), //{0}은(는) 팔수 입력 값 입니다.
				gqmsTitle: yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('MWCC000519')])), //{0}은(는) 팔수 입력 값 입니다.
				gqmsConts: yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('MWCC000845')])) //{0}은(는) 팔수 입력 값 입니다.
				//regId: yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('MWCC000844')])), //{0}은(는) 팔수 입력 값 입니다.
			});
		},
		rtnFile() {
			if (this.UploadFormModalValue.flg == 'I') {
				return [];
			} else {
				return this.UploadFormModalValue.fileList;
			}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		test() {
			//console.log('test입니다.');
		},
		singleFile(files) {
			//console.log('single부모창', files);
			this.setModalValue_({ key: 'fileList', value: files });
			//console.log('single전달확인', this.UploadFormModalValue.imgfile1);
		},
		multiFile(files, delFiles) {
			//console.log('부모창', files, delFiles);
			this.setModalValue_({ key: 'fileList', value: files });
			//console.log('전달확인', this.UploadFormModalValue.fileList);
		},

		// handleRemove(file, fileList) {
		// 	console.log(file, fileList);
		// },

		/* 이미지 1번 관련 함수 시작 */
		handlePictureCardPreview1(imgfile1) {
			//console.log(imgfile1.url);
			this.dialogImageUrl1 = imgfile1.url;
		},
		handleUploadRemove1(oneFile, imgFile1List) {
			//oneFile: 변경된 파일  fileList: 전체 파일리스트
			//this.fileList = fileList;
			this.setModalValue_({ key: 'imgFile1', value: imgFile1List });
			if (this.imgFile1List == null) {
				//this.fileList = [];
				this.setModalValue_({ key: 'imgFile1', value: [] });
			}
			// this.dialogVisible1 = true;
		},
		GeneralFileUploadChange1(oneFile, imgFile1List) {
			// console.log('fileList', fileList);
			this.setModalValue_({ key: 'imgFile1', value: imgFile1List });
			// this.dialogVisible1 = false;
		},

		/* 이미지 2번 관련 함수 시작 */
		handlePictureCardPreview2(imgfile2) {
			//console.log(imgfile2.url);
			this.dialogImageUrl2 = imgfile2.url;
		},
		handleUploadRemove2(oneFile, imgFile2List) {
			//oneFile: 변경된 파일  fileList: 전체 파일리스트
			//this.fileList = fileList;
			this.setModalValue_({ key: 'imgFile2', value: imgFile2List });
			if (this.imgFile2List == null) {
				//this.fileList = [];
				this.setModalValue_({ key: 'imgFile2', value: [] });
			}
			// this.dialogVisible2 = true;
		},
		GeneralFileUploadChange2(oneFile, imgFile2List) {
			// console.log('fileList', fileList);
			this.setModalValue_({ key: 'imgFile2', value: imgFile2List });
			// this.dialogVisible2 = false;
		},

		/* 첨부파일 관련 함수 시작 */
		GeneralFileUploadChange(oneFile, fileList) {
			// console.log('fileList', fileList);
			this.setModalValue_({ key: 'fileList', value: fileList });
		},
		handleUploadRemove(oneFile, fileList) {
			//oneFile: 변경된 파일  fileList: 전체 파일리스트
			//this.fileList = fileList;
			this.setModalValue_({ key: 'fileList', value: fileList });
			if (this.fileList == null) {
				//this.fileList = [];
				this.setModalValue_({ key: 'fileList', value: [] });
			}
			// this.dialogVisible1 = true;
		},

		addAction() {
			try {
				// 유효성 검사
				this.schema.validateSync(this.UploadFormModalValue);

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('MWCC000503'), //추가하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001488'), clickFn: () => this.add() }] //추가
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		add() {
			const formData = new FormData();

			this.$sf_toggleLoading(true);
			//console.log('this.UploadFormModalValue', this.UploadFormModalValue);
			Object.keys(this.UploadFormModalValue).forEach(key => formData.append(key, this.UploadFormModalValue[key]));

			// console.log('fileList', this.UploadFormModalValue.fileList.length);

			// this.UploadFormModalValue.fileList.forEach(element => console.log('element.raw', element));

			if (this.UploadFormModalValue.fileList.length > 0) {
				this.UploadFormModalValue.fileList.forEach(element => formData.append('fileList', element));
			} else {
				formData.append('fileList', '');
			}
			// // debugger;
			// // console.log('this.UploadFormModalValue.fileList', this.UploadFormModalValue.fileList);
			// // formData.append('fileList', this.UploadFormModalValue.fileList);

			// // this.$sf_toggleLoading(false);
			// // return false;

			/* 이미지파일1 */
			//console.log('this.UploadFormModalValue.imgFile1.length ::::: ' + this.UploadFormModalValue.imgFile1.length);
			if (this.UploadFormModalValue.imgFile1.length > 0)
				this.UploadFormModalValue.imgFile1.forEach(element => formData.append('imgFile1', element.raw));
			else formData.append('imgFile1', '');

			/* 이미지파일2 */
			//console.log('this.UploadFormModalValue.imgFile2.length ::::: ' + this.UploadFormModalValue.imgFile2.length);
			if (this.UploadFormModalValue.imgFile2.length > 0)
				this.UploadFormModalValue.imgFile2.forEach(element => formData.append('imgFile2', element.raw));
			else formData.append('imgFile2', '');

			this.addUploadForm_({ formData })
				.then(response => {
					if (response.code == 0) {
						this.$sf_toast({ type: 'ok', message: 'Excel Upload Success!' });
						this.select_({ ...this.searchParams, currentPage: 1, pageUnit: this.groups.pageUnit });
						this.closeModal();
					} else {
						this.$sf_toast({ type: 'error', message: response.message });
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
					Promise.reject(error);
					this.$sf_toggleLoading(false);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		saveAction() {
			try {
				// 유효성 검사
				this.schema.validateSync(this.UploadFormModalValue);

				if (!this.UploadFormModalValue.gqmsSeq)
					this.$sf_toast({
						type: 'error',
						message: this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('MWCC000360')])
					});

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('MWCC000553'), //수정하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000279'), clickFn: () => this.save() }] //수정
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		save() {
			const formData = new FormData();

			this.$sf_toggleLoading(true);
			Object.keys(this.UploadFormModalValue).forEach(key => formData.append(key, this.UploadFormModalValue[key]));
			if (this.UploadFormModalValue.fileList.length > 0)
				this.UploadFormModalValue.fileList.forEach(element => formData.append('fileList', element.raw));
			else formData.append('fileList', '');

			/* 이미지파일1 */
			//console.log('this.UploadFormModalValue.imgFile1.length ::::: ' + this.UploadFormModalValue.imgFile1.length);
			if (this.UploadFormModalValue.imgFile1.length > 0)
				this.UploadFormModalValue.imgFile1.forEach(element => formData.append('imgFile1', element.raw));
			else formData.append('imgFile1', '');

			/* 이미지파일2 */
			//console.log('this.UploadFormModalValue.imgFile2.length ::::: ' + this.UploadFormModalValue.imgFile2.length);
			if (this.UploadFormModalValue.imgFile2.length > 0)
				this.UploadFormModalValue.imgFile2.forEach(element => formData.append('imgFile2', element.raw));
			else formData.append('imgFile2', '');

			//console.log('formData', formData);

			// 1. 수정저장 진행
			this.saveUploadForm_({ formData })
				.then(response => {
					//console.log('수정후 조회 하는지 확인', response.code);
					if (response.code == 0) {
						this.$sf_toast({ type: 'ok', message: 'File Upload Success!' });
						// 2. 완료되면 목록 조회 진행
						this.getUploadFormList_({ ...this.searchParams, currentPage: 1, pageUnit: this.groups.pageUnit });
						this.closeModal();
					} else {
						this.$sf_toast({ type: 'error', message: response.message });
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
					Promise.reject(error);
					this.$sf_toggleLoading(false);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		closeModal() {
			this.closeModal_();
			//this.$refs.fileArea.clearFile();
		}

		// handleRemove(file) {
		// 	console.log(file);
		// },
		// handlePictureCardPreview(file) {
		// 	this.dialogImageUrl = file.url;
		// 	this.dialogVisible = true;
		// }
	}
};
</script>
<style lang=""></style>
